module.exports = __webpack_public_path__ + "static/img/logo_login.fb00aee1.png";